<script setup>
import { TagsInputItemDelete } from 'radix-vue'
import { XIcon } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})
</script>

<template>
  <TagsInputItemDelete
    v-bind="props"
    :class="cn(
      'rounded-full outline-none ring-offset-background transition-opacity hover:opacity-70 focus:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2',
      props.class
    )"
  >
    <slot>
      <XIcon class="h-3 w-3" />
    </slot>
  </TagsInputItemDelete>
</template>
